import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const navLinks = [{
  label: 'Soluciones',
  href: '#soluciones'
}, {
  label: 'Planes',
  href: '#planes'
}, {
  label: 'Plataforma',
  href: '#plataforma'
}, {
  label: 'GPS',
  href: '#gps'
}, {
  label: 'Nosotros',
  href: '#nosotros'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };
  return <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-primary/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`} data-id="element-260">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-261">
          <div className="flex items-center justify-between h-16 md:h-20" data-id="element-262">
            {/* Logo */}
            <a href="#" className="flex items-center space-x-1" data-id="element-263">
              <span className="font-heading font-bold text-xl md:text-2xl text-white tracking-tight" data-id="element-264">
                TrackerSpace
              </span>
              <span className="font-heading font-bold text-xl md:text-2xl text-brand-accent" data-id="element-265">
                Mx
              </span>
            </a>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8" data-id="element-266">
              {navLinks.map(link => <button key={link.href} onClick={() => scrollToSection(link.href)} className="font-subheading text-sm text-brand-text-secondary hover:text-white transition-colors duration-200" data-id="element-267">
                  {link.label}
                </button>)}
            </div>

            {/* CTA Button */}
            <div className="hidden md:block" data-id="element-268">
              <button onClick={() => scrollToSection('#contacto')} className="bg-brand-accent text-brand-bg font-subheading font-semibold px-5 py-2.5 rounded-lg hover:bg-brand-accent/90 transition-all duration-200 hover:shadow-lg hover:shadow-brand-accent/25" data-id="element-269">
                Solicitar Cotización
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden p-2 text-white" aria-label="Toggle menu" data-id="element-270">
              {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-271" /> : <MenuIcon className="w-6 h-6" data-id="element-272" />}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-273">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-40 bg-brand-bg/98 backdrop-blur-lg md:hidden" data-id="element-274">
            <div className="flex flex-col items-center justify-center h-full space-y-8 pt-20" data-id="element-275">
              {navLinks.map((link, index) => <motion.button key={link.href} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} onClick={() => scrollToSection(link.href)} className="font-heading text-2xl text-white hover:text-brand-accent transition-colors" data-id="element-276">
                  {link.label}
                </motion.button>)}
              <motion.button initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.6
          }} onClick={() => scrollToSection('#contacto')} className="mt-4 bg-brand-accent text-brand-bg font-subheading font-semibold px-8 py-3 rounded-lg" data-id="element-277">
                Solicitar Cotización
              </motion.button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}